export const animalProducts = [
  {
    id: 'eggs',
    name: 'Eggs',
    variants: [
      { rarity: 'Common', biopoints: 18.3, productionTime: 1800 },
      { rarity: 'Uncommon', biopoints: 63, productionTime: 1800 },
      { rarity: 'Rare', biopoints: 91, productionTime: 1800 },
      { rarity: 'Epic', biopoints: 123, productionTime: 1800 },
      { rarity: 'Legendary', biopoints: 224, productionTime: 1800 }
    ],
    sourceAnimals: ['Birds']
  },
  {
    id: 'milk',
    name: 'Milk',
    variants: [
      { rarity: 'Common', biopoints: 272, productionTime: 6600 },
      { rarity: 'Uncommon', biopoints: 466, productionTime: 6600 },
      { rarity: 'Rare', biopoints: 661, productionTime: 6600 },
      { rarity: 'Epic', biopoints: 855, productionTime: 6600 },
      { rarity: 'Legendary', biopoints: 1516, productionTime: 6600 }
    ],
    sourceAnimals: ['Cattle']
  },
  {
    id: 'wool',
    name: 'Wool',
    variants: [
      { rarity: 'Common', biopoints: 469, productionTime: 13800 },
      { rarity: 'Uncommon', biopoints: 863, productionTime: 13800 },
      { rarity: 'Rare', biopoints: 1334, productionTime: 13800 },
      { rarity: 'Epic', biopoints: 2194, productionTime: 13800 },
      { rarity: 'Legendary', biopoints: 3526, productionTime: 13800 }
    ],
    sourceAnimals: ['Fuzzies']
  },
  {
    id: 'truffle',
    name: 'Truffle',
    variants: [
      { rarity: 'Common', biopoints: 4100, productionTime: 14400 }
    ],
    sourceAnimals: ['Piggies']
  }
];
